module.exports = __webpack_public_path__ + "img/cloud-top-right.0d6af6ad.svg";